// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r7XmQ","rootNoMargin":"styles_rootNoMargin__3UOvi"};